export default {
  appTitle: process.env.VUE_APP_TITLE,
  backendUrl: process.env.VUE_APP_BACKEND_URL,
  gatewayUrl: process.env.VUE_APP_GATEWAY_URL,
}
